// extracted by mini-css-extract-plugin
module.exports = {"disabled":"DataViewHeaderButton_disabled","enabled":"DataViewHeaderButton_enabled","root":"DataViewHeaderButton_root"};